import { Configuration, LogLevel } from '@azure/msal-browser'

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID ?? '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID ?? 'common'}`,
    redirectUri: `${window.location.origin}/auth/callback`,
    postLogoutRedirectUri: `${window.location.origin}/login`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (_level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii || !import.meta.env.DEV) return
        if (_level === LogLevel.Error) console.error(`MSAL: ${message}`)
        if (_level === LogLevel.Warning) console.warn(`MSAL: ${message}`)
      },
    },
  },
}

// Required scopes — User.Read is the only Graph scope allowed in the frontend.
// All other Graph calls go via the FRIDAY Worker backend.
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
}
